import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=70a055ce&scoped=true"
import script from "./CategoryModal.vue?vue&type=script&lang=js"
export * from "./CategoryModal.vue?vue&type=script&lang=js"
import style0 from "./CategoryModal.vue?vue&type=style&index=0&id=70a055ce&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a055ce",
  null
  
)

export default component.exports